import { render } from "./BaseHeader.vue?vue&type=template&id=2fd8e256&scoped=true"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=2fd8e256&scoped=true&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd8e256"]])

export default __exports__